// utils/api.js
import axios from 'axios';

const API_BASE = 'https://www.nnnco.io/v3/api/core';

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { headers: { authorization: `Bearer ${token}` } } : {};
};

export const loginUser = async (email, password) => {
  const res = await axios.post(`${API_BASE}/login`, { email, password });
  return res.data;
};

export const getDeviceDetails = async (devEui) => {
  const url = `${API_BASE}/commissioning/devices/${devEui}`;
  const res = await axios.get(url, getAuthHeader());
  return res.data;
};

export const getDeviceDiagnostics = async (devEui) => {
  const url = `${API_BASE}/commissioning/devices/${devEui}/diagnostics`;
  const res = await axios.get(url, getAuthHeader());
  return res.data;
};

export const getDeviceTypes = async () => {
  const url = `${API_BASE}/commissioning/device-types`;
  const res = await axios.get(url, getAuthHeader());
  return res.data;
};

export const getDeviceFields = async (typeId) => {
  const url = `${API_BASE}/commissioning/device-types/${typeId}`;
  const res = await axios.get(url, getAuthHeader());
  return res.data.fields || [];
};

export const updateDeviceType = async (deviceId, deviceType) => {
  const token = localStorage.getItem('token');
  const res = await axios.put(
    `${API_BASE}/devices/${deviceId}/type`,
    { deviceType },
    { headers: { authorization: `Bearer ${token}` } }
  );
  return res; 
};

export const updateDeviceMetadata = async (deviceId, metadata) => {
  const token = localStorage.getItem('token');
  return await axios.put(
    `${API_BASE}/devices/${deviceId}/custom-metadata`,
    metadata,
    { headers: { authorization: `Bearer ${token}` } }
  );
};

export const uploadDeviceImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  // Replace with real upload endpoint when available
  const res = await axios.post('http://localhost:4000/api/upload', formData);
  return res.data.imageUrl;
};


export const saveDeviceMetadata = async (payload) => {
  // Replace with real save endpoint when available
  const res = await axios.post('http://localhost:4000/api/save', payload);
  return res.data;
};
